import { render } from "./qingshui.vue?vue&type=template&id=71271401&scoped=true"
const script = {}

import "./qingshui.vue?vue&type=style&index=0&id=71271401&scoped=true&lang=css"

import exportComponent from "/Users/hansteve/Desktop/work/qingshui/qingshui_home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71271401"]])

export default __exports__